import { useEffect } from 'react';
import ServiceTypesConceptsTable from './ServiceTypesConceptsDataTable/ServiceTypesConceptsDataTable';
import ServiceTypesConceptsDataTable from './ServiceTypesConceptsDataTable/ServiceTypesConceptsDataTable';

function ServiceTypeConcepts() {

  // #region Events

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  }, []);

  // #endregion

  // #region Templates

  const viewTemplate = (
    <>
      <article>
        <section>
          <h1>
            Conceptos de Tipos de Servicio
          </h1>
        </section>
        <section>
          <ServiceTypesConceptsDataTable/>
        </section>
      </article>
    </>
  );

  // #endregion

  return (
    <>
      {viewTemplate}
    </>
  );
}

export default ServiceTypeConcepts;